import { ShowSnackbar } from "./types";
import { Module } from "vuex";
import { RootState } from "@/store/types";
import { actions } from "./actions";
import { mutations } from "./mutations";

export const state: ShowSnackbar = {
  showSnackbar: false,
  message: ""
};

const namespaced = true;

export const showsnackbar: Module<ShowSnackbar, RootState> = {
  namespaced,
  state,
  actions,
  mutations
};
